import React from "react";
import AppointmentsApp from "./AppointmentsApp";

const OpsAppointmentsTab = ({ organizationRef, practitionerRef }) => {
  if (!organizationRef || !practitionerRef) return null;
  return (
    <AppointmentsApp
      organizationRef={organizationRef}
      practitionerRef={practitionerRef}
      readOnly
      dashboard
    />
  );
};

export default OpsAppointmentsTab;
